import { h } from 'vue'


const approvalStateList = {
  10: 'info', // 待审批
  20: 'warning', // 已撤回
  30: 'danger', // 已驳回
  40: 'success', // 已通过
}

export const contractConf = function (conf = {}) {
  const tableColumns = [
    {
      name: 'contractId',
      columnProps: {
        prop: 'contractId',
        label: '合同编号',
      },
    },
    {
      name: 'typeName',
      columnProps: {
        prop: 'typeName',
        label: '合同类型',
      },
    },
    {
      name: 'signChannelName',
      columnProps: {
        prop: 'signChannelName',
        label: '签署方式',
      },
    },
    {
      name: 'stateName',
      columnProps: {
        prop: 'stateName',
        label: '签署状态',
      },
      render: ({ row }) => {
        return h('el-tag', { props: { type: row.state === 2 ? 'success' : 'warning' } }, row.stateName)
      },
    },
    {
      name: 'createTime',
      columnProps: {
        prop: 'createTime',
        label: '签约时间',
      },
    },
    {
      name: 'invalidTime',
      columnProps: {
        prop: 'invalidTime',
        label: '解约时间',
      },
    },
    {
      name: 'operate',
      columnProps: {
        label: '操作',
        fixed: 'right',
      },
      type: 'operate',
      getOperateList: ({ row }) => {
        if (row.state === 2) {
          return [
            {
              name: 'donwloadFile',
              label: '下载合同附件',
              action: () => conf.donwloadFile(row),
            },
          ]
        }
      },
    },
  ]

  return {
    tableColumns,
  }
}

export const signLogConf = function () {
  const signLogColumns = [
    {
      name: 'operateTime',
      columnProps: {
        prop: 'operateTime',
        label: '操作时间',

      },
    },
    {
      name: 'content',
      columnProps: {
        prop: 'content',
        label: '操作内容',
      },
    },
    {
      name: 'operateUser',
      columnProps: {
        prop: 'operateUser',
        label: '操作人',
      },
    },
    {
      name: 'approvalStateName',
      columnProps: {
        prop: 'approvalStateName',
        label: '审核状态',
      },
      render: ({ row }) => {
        const { approvalState, approvalStateName } = row
        const stateType = approvalStateList[approvalState]
        if (!stateType) return '--'
        return h('el-tag', { props: { type: stateType } }, approvalStateName)
      },
    },
    {
      name: 'futureSignState',
      columnProps: {
        prop: 'futureSignState',
        label: '操作后签约状态',
      },
    },
    {
      name: 'remarks',
      columnProps: {
        prop: 'remarks',
        label: '备注',
      },
    },
  ]
  return {
    title: '签署日志',
    signLogColumns,
  }
}


export const signState = {
  99: {
    text: '未开启',
    type: 'info',
  },
  0: {
    text: '待确认',
    type: '',
  },
  1: {
    text: '已签约',
    type: 'success',
  },
  2: {
    text: '已解约',
    type: 'warning',
  },
}
